import React from 'react';
import { useState, useEffect, useRef, Fragment } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

import * as Icons from 'react-bootstrap-icons';

import Confirmation from './ConfirmationModal';

const OrganizationAdd = ({ show, callback }) => {
  //const handleClose = () => set
  //console.log('organization', show)
  //const [show, setShow] = useState(false);
  //const handleClose = () => setShow(false);
  const [addFormData, setAddFormData] = useState({
    name: '',
    address: ''
  })

  const handleAddFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute('name');
    const fieldValue = event.target.value;

    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;

    setAddFormData(newFormData);

    console.log('handleSave-newFormData', newFormData)
  }


  const handleSave = (event) => {
    event.preventDefault();
    console.log('handleSave', addFormData)
    callback(addFormData);
  }

  const closeForm = () => {
    callback("close");
  }

  return (
    <>
      <Modal
        show={show}
        onHide={closeForm}
        backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Add Organization</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSave}>
            <Form.Label>Nimi</Form.Label>
            <Form.Control name="name" type="text" placeholder="Nimi" onChange={handleAddFormChange} />

            <Form.Label>Yhteyshenkilö</Form.Label>
            <Form.Control name="contact" type="text" placeholder="Yhteyshenkilö" onChange={handleAddFormChange} />

            <Form.Label>Osoite</Form.Label>
            <Form.Control name="address" type="text" placeholder="Osoite" onChange={handleAddFormChange} />

            <Form.Label>Osoite2</Form.Label>
            <Form.Control name="address2" type="text" placeholder="Osoite 2" onChange={handleAddFormChange} />

            <Form.Label>Postinumero</Form.Label>
            <Form.Control name="postalcode" type="text" placeholder="Postinumero" onChange={handleAddFormChange} />

            <Form.Label>Kaupunki</Form.Label>
            <Form.Control name="city" type="text" placeholder="Kaupunki" onChange={handleAddFormChange} />

            <Form.Label>Y-tunnus</Form.Label>
            <Form.Control name="ytunnus" type="text" placeholder="Y-tunnus" onChange={handleAddFormChange} />

            {/*<Button type="submit">Save</Button>*/}
          </Form>

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={closeForm}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </Modal.Footer>

      </Modal>
    </>
  )
}










// Näytettävä organization rivi
const ReadOnlyRow = ({ organization, handleEditClick, handleDeleteRow }) => {
  /*
  if (confirm("Oletko varma?")) {
    
  }
*/
/*
  const confirmation_callback = () =>{
    console.log('confirmation callback')
  }
*/


  //const [showConfirmation, setShowConfirmation] = useState(true);

  console.log('edit read only row begin')
  return (
    <tr>
      <td><b>{organization['id']}</b></td>
      <td><b>{organization['name']}</b></td>
      <td>{organization['contact']}</td>
      <td>{organization['address']}</td>
      <td>{organization['address2']}</td>
      <td>{organization['postalcode']}</td>
      <td>{organization['city']}</td>
      <td>{organization['ytunnus']}</td>
      {/*<Confirmation show={showConfirmation} callback={confirmation_callback}></Confirmation>*/}
      <td>
        <button className="btn btn-primary" title="Edit" onClick={(event) => handleEditClick(event, organization)}><Icons.Pencil /></button>
        <button className="btn btn-primary" title="Delete" onClick={() => handleDeleteRow(organization['id'])}><Icons.Trash /></button>
      </td>
    </tr>
  )

}

// Editoitava organization rivi
const EditableRow = ({ editFormData, handleEditFormChange, handleCancelClick }) => {
  console.log('edit able row begin', editFormData)
  return (
    <tr>
      <td><b>{editFormData.id}</b></td>
      <td><b><input type="text" required="required" placeholder="Enter a name" name="name" value={editFormData.name} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter a contact name" name="contact" value={editFormData.contact} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter address" name="address" value={editFormData.address} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter address 2" name="address2" value={editFormData.address2} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter postal code" name="postalcode" value={editFormData.postalcode} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter city" name="city" value={editFormData.city} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" required="required" placeholder="Enter ytunnus" name="ytunnus" value={editFormData.ytunnus} onChange={handleEditFormChange} ></input></b></td>

      <td>
        <button className="btn btn-primary" type="button" onClick={handleCancelClick}>Cancel</button>
        <button className="btn btn-primary" type="submit">Save</button>
      </td>
    </tr>
  )
}







const Organizations = ({ organizations, main_callback }) => {
  console.log('edit organization starts')
  const [show, setShow] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [editOrganizationId, setEditOrganizationId] = useState(null);
  // Poistettavan rivin id (HUOM! ei indeksi). Tietoa käytetään ainoastaan rivin poiston yhteydessä
  const [rowIdToDelete, setRowIdToDelete] = useState(null);
/*
  const [editFormData, setEditFormData] = useState({
    id: "",
    name: "",
    contact: "",
    address: "",
    address2: "",
    postalcode: "",
    city: "",
    ytunnus: "",
  })
*/

  const [editFormData, setEditFormData] = useState([]);


  const eventFromChild = (event) => {
    console.log('event from child', event)
    // TODO: Laitetaanko tähän tallennus vai viedäänkö Appin tasolle?
    // Suljettaessa formia tulee ainoastaan teksti close
    if (event !== "close")
      main_callback('add', 'organizations', event);

    setShow(false);
  }

  // Edit kenttää muutettu
  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);

    console.log('edit changed', newFormData)
  };

  // Editoitavalla rivillä painetaan save-nappia
  const handleEditFormSubmit = (event) => {
    event.preventDefault();

    const editedOrganization = {
      id: editOrganizationId,
      name: editFormData.name,
      contact: editFormData.contact,
      address: editFormData.address,
      address2: editFormData.address2,
      postalcode: editFormData.postalcode,
      city: editFormData.city,
      ytunnut: editFormData.ytunnus
    }

    const newOrganization = [...organizations];
    const index = organizations.findIndex((organization) => organization.id === editFormData.id);
    newOrganization[index] = editFormData;
    //setEditFormData(newOrganization);
    console.log('edit submit', editOrganizationId, newOrganization)
    
    main_callback('update', 'organizations', newOrganization);
    
    setEditOrganizationId(null);
  }

  // Editoitavalla painetaan cancel-nappia
  const handleCancelClick = () => {
    console.log('edit cancelled')
    setEditOrganizationId(null);
  }


  // ReadOnly-rivillä painetaan edit-nappia
  const handleEditClick = (event, organization) => {
    console.log('edit click', event, organization)
    event.preventDefault();
    setEditOrganizationId(organization.id);

    const formValues = {
      id: organization.id,
      name: organization.name,
      address: organization.address,
      address2: organization.address2,
      postalcode: organization.postalcode,
      city: organization.city,
      contact: organization.contact,
      //phoneNumber: organization.phoneNumber,
      //email: organization.email,
      ytunnus: organization.ytunnus
    };

    console.log('edit click form', formValues)

    setEditFormData(formValues);
    console.log('edit click after', editFormData)
  };

  // Read-only rivillä painetaan deleteä -> näytetään varmistusdialogi (alla)
  const handleDeleteRow = (id) => {
    console.log('handleDeleteRow', id)
    setRowIdToDelete(id);

    // Kysytään varmistus poistoon
    setShowConfirmation(true);
  }

  // Jos käyttäjä vahvistaa poiston -> lähetetään backendille poistettavan rivin id
  const confirmation_callback = (confirmation) =>{
    if (confirmation === "confirm") {
      main_callback('delete', 'organizations', rowIdToDelete)
      setRowIdToDelete(null);
    }

    // Piiletetaan lopuksi vahvistusdialogi
    setShowConfirmation(false);
  }


  return (
    <>
      <h2>Organisaatiot</h2>
      <form onSubmit={handleEditFormSubmit}>
        <Table>
          <thead>
            <tr>
              <th>Id</th>
              <th>Nimi</th>
              <th>Kontakti</th>
              <th>Osoite</th>
              <th>Osoite 2</th>
              <th>Postinumero</th>
              <th>Kaupunki</th>
              <th>Y-tunnus</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {organizations.map((organization) => (
              
              <Fragment  >
                {editOrganizationId === organization.id ? (
                  <EditableRow key={organization.id} editFormData={editFormData} handleEditFormChange={handleEditFormChange} handleCancelClick={handleCancelClick} />
                  ) : (
                  <ReadOnlyRow key={organization.id} organization={organization} handleEditClick={handleEditClick} handleDeleteRow={handleDeleteRow} />
                  )
                }
              </Fragment>
            ))}

          </tbody>
        </Table>
      </form>
      <OrganizationAdd show={show} callback={eventFromChild}></OrganizationAdd>

      <Confirmation className="delete-confirmation" show={showConfirmation} callback={confirmation_callback}></Confirmation>

      <button
        className="btn btn-primary"
        onClick={() => setShow(true)}>
        Lisää
      </button>
    </>

  )

  /*
      return (
          <>
          <h4>Organisaatiot</h4>


          <Table>
          <thead>
            <tr>
              <th>Id</th>
              <th>Nimi</th>
              <th>Kontakti</th>
              <th>Osoite</th>
              <th>Osoite 2</th>
              <th>Postinumero</th>
              <th>Kaupunki</th>
              <th>Y-tunnus</th>
              <th>Actions</th>
            </tr>
          </thead>
  
          <tbody>
            {organizations.map((item, index) => {
              //let site = item['name'];
              return (
                  <tr key={item['id']}>
                    <td><b>{item['id']}</b></td>
                    <td><b>{item['name']}</b></td>
                    <td>{item['contact']}</td>
                    <td>{item['address']}</td>
                    <td>{item['address2']}</td>
                    <td>{item['postalcode']}</td>
                    <td>{item['city']}</td>
                    <td>{item['ytunnus']}</td>
                    <td>
                      <button class="btn btn-primary" title="Edit" onClick={() => handleEditRow(item['id'], index)}><Icons.Pencil/></button>
                      <button class="btn btn-primary" title="Delete" onClick={() => handleDeleteRow(item['id'], index)}><Icons.Trash/></button>
                    </td>
                  </tr>
              )
            })}
          </tbody>
        </Table>
  
        <OrganizationAdd show={show} callback={eventFromChild}></OrganizationAdd>
            <button  
              className="btn btn-primary" 
              onClick={() => setShow(true)}>
                
            </button>
        </>
        
      )
   */
}

export default Organizations;
